import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '../../../../assets/check-circle-green.svg'


const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "flex justify-between" }
const _hoisted_3 = { class: "font-bold text-gray-700" }
const _hoisted_4 = { class: "text-green-500 font-medium" }
const _hoisted_5 = { class: "mt-4" }
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col justify-between line mb-5" }, [
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }),
  /*#__PURE__*/_createElementVNode("img", { src: _imports_0 })
], -1)
const _hoisted_8 = { class: "pl-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold" }, "From", -1)
const _hoisted_10 = { class: "mt-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold" }, "To", -1)
const _hoisted_12 = { class: "border-t mt-4 pt-4" }
const _hoisted_13 = { class: "grid grid-cols-4" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Submitted", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Distance", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Duration", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("p", null, "N/A", -1)
const _hoisted_18 = { class: "font-bold" }
const _hoisted_19 = {
  key: 1,
  class: "d-flex"
}
const _hoisted_20 = { class: "px-3 font-bold text-gray-700" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    role: "button",
    class: _normalizeClass(["rounded-lg shadow p-4", {'bg-gray-50':!_ctx.isExtended}]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isExtended = !_ctx.isExtended))
  }, [
    (_ctx.isExtended)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.order.orderId), 1),
            _createElementVNode("span", null, _toDisplayString(_ctx.moment(_ctx.order.createdAt).format('hh:mm A')), 1)
          ]),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.order.orderStatus.value), 1),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", null, [
                  _hoisted_9,
                  _createElementVNode("div", null, _toDisplayString(_ctx.order.darkStore.name), 1)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("div", null, _toDisplayString(_ctx.order.userAddress), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("p", null, _toDisplayString(_ctx.moment(_ctx.order.createdAt).format('hh:mm A')), 1),
              _hoisted_15,
              _createElementVNode("p", null, _toDisplayString(_ctx.distance || 0), 1),
              _hoisted_16,
              _hoisted_17,
              _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$t('orders.binNo')), 1),
              _createElementVNode("p", null, _toDisplayString(_ctx.order.orderBinNumber), 1)
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createElementVNode("span", null, _toDisplayString(_ctx.moment(_ctx.order.createdAt).format('hh:mm A')), 1),
          _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.order.orderId), 1)
        ]))
  ], 2))
}